export default { 
  hd93dde07c09bff6ff77c44befb7851e0: [[({}, [C0, C1]) => ["\xA9 ", C0(), " ", C1()], {}]] 
}